import React from 'react';
import { withRouter } from 'react-router-dom';
import MainLayout from '@pages/main-layout/main-layout-page';
import { LoginRoutes, HomeRoutes } from '@routes';
import './App.css';

function App() {
	return <LoginRoutes />;
}

export default withRouter(App);
